module.exports = __webpack_public_path__ + "wafuss4.325b06ab96046006d04072e8c0901aa1.png";